var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStoreTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2628 11.845C16.6533 11.4545 16.6533 10.8213 16.2628 10.4308L9.27043 3.4384C9.0763 3.24428 8.81091 3.1385 8.53648 3.14587L4.23419 3.2614C3.70295 3.27566 3.27566 3.70295 3.2614 4.23419L3.14587 8.53648C3.1385 8.81091 3.24428 9.0763 3.4384 9.27043L10.4308 16.2628C10.8213 16.6533 11.4545 16.6533 11.845 16.2628L16.2628 11.845ZM6.96316 6.19249C6.96316 6.61812 6.61812 6.96316 6.19249 6.96316C5.76685 6.96316 5.42181 6.61812 5.42181 6.19249C5.42181 5.76685 5.76685 5.42181 6.19249 5.42181C6.61812 5.42181 6.96316 5.76685 6.96316 6.19249Z",
    fill: "#555555"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.35355 0.646447C1.15829 0.451184 0.841709 0.451184 0.646447 0.646447C0.451184 0.841709 0.451184 1.15829 0.646447 1.35355L1.35355 0.646447ZM6.0017 5.2946L1.35355 0.646447L0.646447 1.35355L5.2946 6.0017L6.0017 5.2946Z",
    fill: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStoreTag);
export default __webpack_public_path__ + "static/media/icon_store_tag.0284e4b341ac43b83f17497f7f6dc49a.svg";
export { ForwardRef as ReactComponent };